import Kuroshiro from "./core";

export default Kuroshiro;
export * from "./types";
